module.exports = __webpack_public_path__ + "static/media/great-gray.913be6b3.svg";